export default __webpack_public_path__ + "static/media/presentation.c81e1e1f.png";